import Vue from 'vue';
// import _ from 'lodash';
import {
    GET_PRINT_ORDER_DETAIL_REQUEST,
    GET_PRINT_ORDER_DETAIL_SUCCESS,
    GET_PRINT_ORDER_DETAIL_FAILURE,
    UPDATE_PRINT_ORDER_DETAIL_PARAMS
} from '../mutationTypes';

const state = {
    isNotData: {
        type: '',
        msg: ''
    },
    loading: false,
    reqParams: {
        orderId: '', // 订单id
        businessType: '', // 业务类型id
    },
    orderDetail: {
        orderInfo: {},
        carInfo: {},
        associatedOrder: {},    // 关联订单信息
        serverInfo: [],         // 服务信息
        goodsInfo: [],          // 商品信息
        settlementInfo: {},     // 结算信息
        buyInfo: [],            // 购买信息
        operate: [],            // 操作记录
    }
};

const mutations = {
    [GET_PRINT_ORDER_DETAIL_REQUEST](state) {
        state.loading = true;
        // reset noData info
        state.isNotData.type = false;
    },
    [GET_PRINT_ORDER_DETAIL_SUCCESS](state, res) {
        state.loading = false;
        const goodsInfo = [];
        res.goodsInfo.forEach((item) => {
            if (item.goodsOrder) {
                item.orderInfo.forEach((orderGoods) => {
                    goodsInfo.push(Object.assign(orderGoods, {goodsOrder: item.goodsOrder}));
                });
            } else {
                goodsInfo.push(item);
            }
        });
        const cache = res;
        cache.goodsInfo = goodsInfo;
        state.orderDetail = cache;
        // reset noData info
        state.isNotData.type = false;
    },
    [GET_PRINT_ORDER_DETAIL_FAILURE](state, res) {
        state.loading = false;
        if (res.errorType) {
            state.isNotData.type = true;
            state.isNotData.msg = res.errmsg;
        } else {
            state.isNotData.type = false;
            state.isNotData.msg = '';
        }
        // reset orderDetail
        state.orderDetail = {};
    },
    [UPDATE_PRINT_ORDER_DETAIL_PARAMS](state, params) {
        const { orderId, businessType } = params;
        if (orderId || orderId === '') state.reqParams.orderId = orderId;
        if (businessType || businessType === '') state.reqParams.businessType = businessType;
    }
};

export const actions = {
    async getPrintOrderDetail({ commit }) {
        commit(GET_PRINT_ORDER_DETAIL_REQUEST);
        const res = await Vue.$ajax.get('getGainDetail', state.reqParams);
        if (!res.errorType) {
            commit(GET_PRINT_ORDER_DETAIL_SUCCESS, res);
        } else {
            commit(GET_PRINT_ORDER_DETAIL_FAILURE, res);
        }
    },
    resolvePrintOrderDetailParams({ commit }) {
        const params = state.reqParams;
        commit(UPDATE_PRINT_ORDER_DETAIL_PARAMS, params);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/printOrder.js